import { useCallback, useEffect, useRef, useState } from "react";

// Debounced explorer search returning {records, property_ids, address_property_ids, ...}.
export function useLiveSearch(client, scopePropertyId) {
  const [q, setQ] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const seq = useRef(0);

  useEffect(() => {
    if (!q.trim()) { setResult(null); setLoading(false); return undefined; }
    setLoading(true);
    const n = (seq.current += 1);
    const t = setTimeout(async () => {
      try { const r = await client.search(q, scopePropertyId); if (n === seq.current) setResult(r); } catch { if (n === seq.current) setResult(null); }
      if (n === seq.current) setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, [q, client, scopePropertyId]);

  const active = !!(q.trim() && result?.active);
  const recordIds = new Set(active ? result.records.map((r) => r.record.id) : []);
  const isVisibleRecord = useCallback((r) => {
    if (!active) return true;
    return recordIds.has(r.id) || (result.address_property_ids || []).includes(r.property_id);
  }, [active, result]); // eslint-disable-line react-hooks/exhaustive-deps
  return { q, setQ, result, loading, active, isVisibleRecord, best: active ? result.records[0] : null };
}
